import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Params, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

export interface IBreadcrumb {
  label: string;
  params: Params;
  url: string;
  type: string;
}

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {

  isDisplayed = true;
  isDisplayedButton = true;
  breadcrumbs: IBreadcrumb[] = [];

  get homeUrl() {
    return this.breadcrumbs.length > 0 && this.breadcrumbs[0].type ? this.breadcrumbs[0].type : '';
  }

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public location: Location,
  ) {}

  ngOnInit(): void {
    this.breadcrumbs = this.getBreadcrumbs(this.activatedRoute.root);

    // subscribe to the NavigationEnd event
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(event => {
      // set breadcrumbs
      const root: ActivatedRoute = this.activatedRoute.root;

      this.breadcrumbs = this.getBreadcrumbs(root);
    });
  }

  /**
   * Returns array of IBreadcrumb objects that represent the breadcrumb
   */
  private getBreadcrumbs(route: ActivatedRoute, url = '', breadcrumbs: IBreadcrumb[] = []): IBreadcrumb[] {
    // get the child routes
    const children: ActivatedRoute[] = route.children;

    // return if there are no more children
    if (children.length === 0) {
      return breadcrumbs;
    }

    const child = this.getDataBread(children);

    if (child.snapshot.data.breadcrumbs === 'undisplayed') {
      this.isDisplayed = false;

      return;
    }

    this.isDisplayedButton = child.snapshot.data.displayButton === false ? false : true;

    const configs = child.snapshot.data.breadcrumbs;

    if (!configs || configs.length === 0 || child.snapshot.url.length === 0) {
      return breadcrumbs;
    }

    let tempUrl;

    configs.forEach(config => {
      tempUrl = config.url && url + '/' + config.url;

      const breadcrumb: IBreadcrumb = {
        label: config.display,
        params: child.snapshot.params,
        url: tempUrl,
        // get type current page
        type: !tempUrl ? null : tempUrl.split('/').length > 3 ? tempUrl.split('/')[tempUrl.split('/').length - 3] : tempUrl.split('/')[1]
      };

      breadcrumbs.push(breadcrumb);
    });

    // breadcrumbs = breadcrumbs.map(item => ({...item, label: item.label.toUpperCase()}));

    url = breadcrumbs[breadcrumbs.length - 1].url;

    return this.getBreadcrumbs(child, url, breadcrumbs);
  }

   public getDataBread(child) {
    if (child[0].children.length !== 0) {
      return this.getDataBread(child[0].children);
    } else {
      return child[0];
    }
  }
}
